import { Fluent, getjQuery, PropertyGrid, trimToEmpty, trimToNull, tryGetText } from "@serenity-is/corelib";

const oldRenderContents = PropertyGrid.prototype["renderContents"];
const newRenderContents = function (...params: any[]) {
    const thisPropertyGrid = this as PropertyGrid & { options: PropertyGrid["options"] };
    const ret = oldRenderContents.apply(thisPropertyGrid, params);

    try {
        const items = thisPropertyGrid.options.items || [];

        let category: string | null = null;
        let pane: HTMLElement | null = null;
        let linkContainer: HTMLElement | null = null;
        for (let itemIdx = 0; itemIdx < items.length; itemIdx++) {
            const item = items[itemIdx];
            const currentField = this.fieldElements[itemIdx];
            const currentPane = currentField.closest(".categories");
            const currentCategory = trimToNull(item.category || null);

            if (!currentPane || !currentCategory) {
                pane = null;
                category = null;
                linkContainer = null;
                continue;
            }

            if (pane !== currentPane) {
                pane = currentPane;
                category = null;

                linkContainer = Fluent("div").class("category-links").getNode();
                pane.prepend(linkContainer);
            }

            if (category !== currentCategory && linkContainer) {
                category = item.category;

                if (linkContainer.childElementCount)
                    linkContainer.prepend(Fluent("div").class("separator").text("|").getNode());

                linkContainer.prepend(Fluent("a")
                    .class("category-anchor")
                    .data("target-category", category)
                    .click((e) => {
                        if (!(e.target instanceof HTMLElement))
                            return;

                        const targetCategory = e.target.dataset["targetCategory"];
                        if (!targetCategory)
                            return;

                        const scrollTarget = e.target.closest(".categories").querySelector("[data-category='" + targetCategory + "']");
                        if (!scrollTarget)
                            return;

                        scrollTarget.scrollIntoView({
                            behavior: "smooth",
                            block: "start"
                        });

                        const title = scrollTarget.querySelector(".category-title");
                        if (!title)
                            return;

                        if (getjQuery()?.fn?.fadeTo) {
                            getjQuery()(title).fadeTo(100, 0.5, function () {
                                    getjQuery()(title).fadeTo(100, 1, function () { });
                                }
                            );
                        }
                    })
                    .text(tryGetText("Categories." + category) ?? trimToEmpty(category)).getNode());
            }
        }
    } catch (e) {
        console.error(e);
    }

    return ret;
}

PropertyGrid.prototype["renderContents"] = newRenderContents;
